<script>
import Repositories from '@/repositories';
const OrderReceptionsRepository = Repositories.get('orderreceptions');
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import dateMixin from '@/mixins/dateMixin';
import ReceivedItemsModal from './modals/received-items.vue';

/**
 * Dashboard Component
 */
export default {
  components: {
    Loading,
    ReceivedItemsModal,
  },
  data() {
    return {
      isLoading: false,
      orderReceptionsList: [],
      orderReceptionIdPublic: null,
    };
  },
  mixins: [dateMixin],
  props: {
    orderIdPublic: String,
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      this.orderReceptionsList = [];
      OrderReceptionsRepository.customREST
        .getByOrder(this.orderIdPublic)
        .then((response) => {
          this.orderReceptionsList = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    showReceivedItemsModal(idPublic) {
      this.orderReceptionIdPublic = idPublic;
      this.$bvModal.show('received-items-modal');
    },
    modalClosed() {
      this.orderReceptionIdPublic = null;
    },
  },
};
</script>

<template>
  <b-container class="receptions-box">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <b-row
      class="reception-row"
      style="background-color: #f1f3f5; font-weight: bold"
    >
      <b-col cols="4" class="reception-col">
        {{ $t('general.number') }}
      </b-col>
      <b-col cols="5" class="text-center reception-col">
        {{ $t('orders.receptionDate') }}
      </b-col>
      <b-col cols="3" class="text-center reception-col">
        {{ $t('items.items') }}
      </b-col>
    </b-row>
    <b-row
      v-if="orderReceptionsList.length == 0"
      class="reception-row text-center"
    >
      <b-col>
        {{ $t('orders.noReception') }}
      </b-col>
    </b-row>
    <b-row
      v-else
      v-for="orderReception in orderReceptionsList"
      :key="orderReception.idPublic"
      class="reception-row"
    >
      <b-col cols="4" class="reception-col">
        {{ orderReception.receptionNumber }}
      </b-col>
      <b-col cols="5" class="text-center reception-col">
        {{ formatDate(orderReception.receptionDate) }}
      </b-col>
      <b-col
        cols="3"
        class="text-center clickable-text flex-vertical-align"
        @click="showReceivedItemsModal(orderReception.idPublic)"
      >
        {{ orderReception.totalItemsQuantity }}
      </b-col>
    </b-row>

    <ReceivedItemsModal
      :orderReceptionIdPublic="orderReceptionIdPublic"
      @modal-closed="modalClosed"
    />
  </b-container>
</template>

<style scoped>
.receptions-box {
  border: 1px solid #ced4da;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 0;
  padding-right: 0;
}
.reception-row {
  padding-right: 8px;
  padding-left: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.reception-col {
  padding-left: 6px;
  padding-right: 6px;
}
</style>